// The same flag gates discovery-react's Discovery Code notification, so the card and the notification
// that opens it stay in step. Testers already have it; no dedicated flag to override.
export const DISCOVERY_CODE_FEATURE_FLAG = 'discovery_prototypes'

export const DISCOVERY_CODE_MIN_VERSION_CODE = 72

/**
 * Whether the installed Together Android app is new enough to handle the Discovery Code schemes. Older
 * builds have no intent filter for them and fail with ERR_UNKNOWN_URL_SCHEME.
 *
 * Prefers the launch URL's `versionCode`, falling back to the copy `useShowTWAUpgradeWarning` mirrors into
 * localStorage. The URL is read directly because that hook writes storage in an effect after first render,
 * so on a fresh launch storage is still empty when this runs. The hook itself is not reused: it drives an
 * upgrade banner, and this feature should stay quiet on old builds instead.
 */
export function isDiscoveryCodeVersionSupported() {
  if (typeof window === 'undefined') return false
  try {
    const urlVersionCode = Number.parseInt(new URLSearchParams(window.location.search).get('versionCode'), 10)
    const versionCode = Number.isNaN(urlVersionCode)
      ? Number.parseInt(window.localStorage.getItem('versionCode'), 10)
      : urlVersionCode
    return !Number.isNaN(versionCode) && versionCode >= DISCOVERY_CODE_MIN_VERSION_CODE
  } catch {
    return false
  }
}
